// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:52:32.387Z
// Property: Ashcroft - a Quinn Residence (ID: 6767906449167635)
// Collections: 9 amenities, 6 floorplans (live), 24 photos, 32 POIs, 3 reviews, 6 virtual tours, 5 office hours, 1 special offers (live), 20 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167635",
  "property_external_id": "1743032",
  "property_zillow_url": "https://www.zillow.com/apartments/columbia-sc/ashcroft/Cn6ct5/",
  "property_apartments_url": "https://www.apartments.com/1607-solandra-drive-columbia-sc/xn5lldm/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57156780639",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ashcroft",
  "property_name": "Ashcroft - a Quinn Residence",
  "property_website_url": "https://www.live-ashcroft.com",
  "property_domain": "https://www.live-ashcroft.com",
  "property_address": "1102 Semoran Way",
  "property_full_address": "1102 Semoran Way, Columbia, SC 29229",
  "property_address_1": "1102 Semoran Way",
  "property_address_2": null,
  "property_address_city": "Columbia",
  "property_address_state": "SC",
  "property_address_zip_full": "29229",
  "property_address_zip": "29229",
  "property_address_country": "US",
  "property_address_county": "Richland County",
  "property_neighborhood_address": null,
  "property_address_latitude": "34.103281",
  "property_address_longitude": "-80.846967",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(855) 783-8729",
  "property_call_tracking_phone": "855-783-8729",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes and townhomes",
  "property_short_description": "<p><strong>Newly built space with a home-style feel.</strong> Ashcroft pairs three- and four-bedroom townhome and single-family layouts with managed-community ease, smart-home features, in-unit laundry, and polished finishes—schedule a tour to see Northeast Columbia living made simple.</p>",
  "property_long_description": "<p><strong>Newly built space, Northeast Columbia convenience.</strong> At Ashcroft, you get the room and feel of a home with the ease of a managed community: three- and four-bedroom <a href=\"/floor-plans\">townhome and single-family layouts</a>, lawn maintenance, in-unit laundry, smart-home technology, and polished finishes like stainless steel appliances, granite countertops, luxury flooring, and spacious closets.</p><p>Days here can move from the <a href=\"/amenities\">pool and clubhouse</a> to the fenced dog park or playground, then out to the best of Northeast Columbia. Village at Sandhill brings shopping, dining, movies, and everyday errands close by, while Sesquicentennial State Park offers pine trails, lake views, paddling, biking, and picnic spots when you want fresh air. With quick access to Clemson Road, Two Notch Road, and the wider Columbia area, Ashcroft keeps your routine connected without giving up a quieter residential setting.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-454d-759d-bc2b-d8b9997c6743.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
    "public_id": "01a188e7-454d-759d-bc2b-d8b9997c6743",
    "storage_key": "property/6767906449167635/01a188e7-454d-759d-bc2b-d8b9997c6743.webp",
    "width": 1280,
    "height": 902
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167635/01a0c013-1783-76ca-a255-b6f1bec9a2b9.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c013-1783-76ca-a255-b6f1bec9a2b9",
    "storage_key": "property/6767906449167635/01a0c013-1783-76ca-a255-b6f1bec9a2b9.mp4",
    "thumbnail_key": "property/6767906449167635/01a0c013-1783-76ca-a255-b6f1bec9a2b9_thumb.webp",
    "size_bytes": 18376016,
    "classification": "Community",
    "title": "Explore Our New Townhomes and Amenities",
    "description": "Take a virtual tour of our modern townhome community, featuring spacious interiors, beautiful exteriors, and exciting amenities like a pool and outdoor lounge area."
  },
  "property_total_units": "251",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "20",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, landscaping $65 (single-family home) or $45 (townhome), smart home package $35, trash valet $33; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval from Quinn Property Management. Dangerous or poisonous animals and exotic pets are not permitted.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets (written approval needed for more). One-time non-refundable pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit per pet and breed restrictions apply; pet screening is required before move-in. Fish allowed with no fee or rent (tanks up to 20 gallons).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://live-ashcroft.securecafe.com/onlineleasing/ashcroft-at-colonel-creek/floorplans.aspx",
  "property_resident_portal_url": "https://live-ashcroft.securecafe.com/residentservices/ashcroft-at-colonel-creek/userlogin.aspx",
  "property_apply_now_url": "https://live-ashcroft.securecafe.com/onlineleasing/ashcroft-at-colonel-creek/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a0ab62-f3d2-77bf-b7d9-dad93904a18e.webp",
  "property_primary_logo_media": {
    "alt_text": "Ashcroft a Quinn Residence logo",
    "public_id": "01a0ab62-f3d2-77bf-b7d9-dad93904a18e",
    "storage_key": "property/6767906449167635/01a0ab62-f3d2-77bf-b7d9-dad93904a18e.webp",
    "width": 197,
    "height": 58
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#593827",
  "property_secondary_color": "#47573d",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1250 - 1726",
  "property_sqft_min": "1250",
  "property_sqft_max": "1726",
  "property_price_range": "1855 - 4015",
  "property_price_min": "1747",
  "property_price_max": "4232",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=100083126509148",
  "property_instagram_url": "https://www.instagram.com/ashcroftcolumbia/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJWzfRL4Gr-IgRs2kEY4C7xm0",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ashcroft",
  "property_home_romance_title": "Create Lasting Memories in Your New Rental Home",
  "property_home_amenities_blurb": "<p><strong>Polished finishes meet everyday ease.</strong> Ashcroft pairs stainless steel appliances, granite countertops, smart-home features, and in-unit laundry with clean, modern flooring throughout. Beyond your door, enjoy time back in your day with lawn maintenance, plus a clubhouse, sparkling pool, playground, and fenced dog park designed for easy downtime close to home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Room to work, unwind, and settle in.</strong> Ashcroft offers three- and four-bedroom floor plans in townhome-style and single-family layouts, pairing the feel of a home with the ease of a managed rental community. Explore polished interiors with granite countertops, stainless steel appliances, luxury flooring, smart-home features, in-unit laundry, spacious closets, and dual vanities in select plans.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Ashcroft in focus.</strong> Preview bright kitchens with granite countertops and stainless steel appliances, open living areas with luxury flooring, and smart storage throughout. Outside, get a glimpse of the pool, clubhouse, and dog park, then explore the full gallery to see how three- and four-bedroom layouts bring everyday comfort together in Columbia.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Northeast Columbia is right at your pace.</strong> From Ashcroft, Clemson Road errands, Sandhills dining, Village at Sandhill movies, and everyday routes via Two Notch Road, I-20, and I-77 stay within easy reach. For a greener reset, Sesquicentennial State Park adds pine-shaded trails, paddling, and picnic space nearby. Explore the neighborhood map, then see how Ashcroft connects it all.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about Ashcroft.</strong> Reviews point to bright, spacious townhome layouts, responsive maintenance, and helpful service from the first tour onward. The walkable sidewalks, welcoming feel, and clubhouse and pool area also earn frequent praise—along with everyday comfort that makes the community easy to enjoy.</p>",
  "property_neighborhood_blurb": "<p><strong>Live close to the Northeast Columbia rhythm.</strong> From Ashcroft, your days can run through the Sandhills area: coffee and errands along Clemson Road, a casual bite at Travinia, Menkoi Ramen, Red Bowl, or Top Dawg Tavern, then a movie or event around Village at Sandhill.</p><p>When you want more trees than traffic lights, Sesquicentennial State Park brings pine-shaded trails, a lake loop, paddling, and picnic space nearby, while Clemson’s Sandhill Research and Education Center adds a rooted local landmark with gardens and walking trails. With The COMET’s Sandhills route, Two Notch Road, I-20, and I-77 in reach, Ashcroft keeps everyday Columbia connections simple. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that handle the everyday, then add the extras.</strong> At Ashcroft, your home is designed to feel polished and practical from the first load of laundry to the last dip in the pool. Cook with stainless steel appliances and granite countertops, keep routines simple with smart-home technology and in-unit laundry, and enjoy luxury flooring that gives each room a clean, modern feel. Outside your front door, lawn maintenance helps free up your schedule, while the clubhouse, pool, playground, and fenced dog park add easy ways to unwind close to home. Browse the <a href=\"/gallery\">amenity photos</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Ashcroft brings comfort and convenience together in Columbia.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Ashcroft.</strong> Newly built three- and four-bedroom townhome and single-family layouts pair home-style space with managed-community ease, from lawn maintenance to in-unit laundry, smart-home technology, and polished finishes. Apply online today and move one step closer to a connected Northeast Columbia address.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about Ashcroft?</strong> Our leasing team is here to help with details on three- and four-bedroom layouts, managed-community conveniences, and directions to our Northeast Columbia location. Reach out today and we’ll help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Ashcroft?</strong> Start here for quick answers about the community, leasing, and everyday living in these newly built townhome and single-family layouts. If you need anything beyond the FAQs, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that gives your day room to work.</strong> Ashcroft’s floor plans lean into the feel of a home, with three- and four-bedroom options that offer defined spaces for cooking, relaxing, storage, and everyday routines. Choose from townhome-style and single-family layouts with the ease of a managed rental community and polished interiors designed to feel fresh from move-in day forward.</p><p>Inside, details like granite countertops, stainless steel appliances, luxury flooring, smart-home features, in-unit laundry, spacious closets, and dual-vanity sinks in select plans help each room function as good as it feels. Compare availability, pricing, and plan styles, then use the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your preferred Ashcroft home comes together in Columbia.</p>",
  "property_gallery_blurb": "<p><strong>See Ashcroft from the inside out.</strong> Browse photos that bring the details into focus: bright kitchens with granite countertops and stainless steel appliances, open living areas with clean luxury flooring, and storage-minded spaces that make each home feel as practical as it looks. Then move outside to the pool, clubhouse, and dog park for a closer look at the everyday spaces beyond your front door. As you click through the gallery, notice how the three- and four-bedroom layouts create room for cooking, relaxing, working, and unwinding while still keeping the ease of a managed community in Columbia. When a favorite view catches your eye, compare <a href=\"/floor-plans\">available floor plans</a>, explore more <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available three- and four-bedroom layouts at Ashcroft, then use the interactive map to see how Northeast Columbia convenience, nearby shopping and dining, outdoor escapes, and connected routes come together around a quieter residential setting.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, whiskers, and wagging tails.</strong> At Ashcroft, pet-friendly living is built into the rhythm of home—not treated like an afterthought. Take your dog to the on-site <a href=\"/amenities\">fenced dog park</a> for off-leash time, enjoy lower-maintenance routines with lawn care handled for you, and come home to spacious layouts with easy-care finishes that stand up to everyday pet life.</p><p>Cats can claim a sunny window, dogs have space to settle in after a romp, and even a small aquarium can add calm to your day. When muddy paws or well-loved blankets happen, in-unit laundry helps keep cleanup simple. Ready to see how your pet’s routine fits here? <a href=\"/schedule-a-tour\">Schedule a tour</a> and explore Ashcroft in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the room, ease, and Northeast Columbia convenience you love.</strong> Invite a friend to discover Ashcroft’s newly built three- and four-bedroom <a href=\"/floor-plans\">townhome and single-family layouts</a>, polished finishes, and connected yet quieter residential setting. Send a referral today and help them find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Ashcroft</strong><br>Manage modern living with ease. Pay rent, submit maintenance requests, and keep your account up to date—so you can get back to enjoying the comfort, convenience, and connected lifestyle of your Ashcroft home.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Ashcroft.</strong> As you browse the reviews, you’ll notice praise for helpful service, modern townhome design, and a community experience that feels easy to enjoy day after day.</p><p>Residents highlight spacious layouts with natural light, friendly neighbors, walkable sidewalks, responsive maintenance, and a clubhouse and pool area they appreciate. One reviewer shared they have “loved every minute,” while another called the customer service during their apartment search the “best” they had experienced.</p>",
  "property_created_at": "1786373611995",
  "property_scheduletour_blurb": "<p><strong>See Ashcroft in person.</strong> Tour brand-new three- and four-bedroom homes with stainless steel appliances, granite countertops, luxury vinyl flooring, smart-home technology, and in-unit laundry. From modern interiors to welcoming community spaces, Ashcroft is designed for comfort and convenience. Schedule your tour today and picture what’s next.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Ashcroft.</strong> We’ve received your inquiry, and our leasing team will follow up soon. In the meantime, picture brand-new three- and four-bedroom homes with modern finishes, smart-home technology, in-unit laundry, and the comfort, convenience, and connectivity of suburban Columbia living.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through every Ashcroft floor plan before you visit.</strong> Start your search with 3D virtual tours of all six layouts—Laurens, Dixon, Underwood, Dahlia, Foxglove, and Townsend—and explore each home at your own pace, from the kitchen’s granite countertops and stainless steel appliances to the luxury flooring, spacious closets, and everyday flow between living spaces. Pause where you need to, look closer at the finishes, and get a feel for how these Columbia townhomes and single-family homes come together before you schedule anything in person.</p><p>When you’re ready to compare layouts, visit <a href=\"/floor-plans\">floor plans</a>, browse more views in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Ashcroft firsthand.</p>",
  "property_copyright": "2026 All Rights Reserved. Ashcroft",
  "property_seo_title_home": "Ashcroft |  Apartments in Columbia, SC",
  "property_seo_description_home": "Experience luxury living at Ashcroft in Columbia, SC! Choose from spacious 3 & 4 bedroom floor plans with top-tier amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Columbia, SC Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Ashcroft in Columbia, SC! Choose from spacious three and four-bedroom floor plans. Your dream apartment awaits—browse now!",
  "property_seo_title_amenities": "Amenities | Columbia, SC Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Ashcroft in Columbia, SC! Enjoy spacious layouts, modern amenities, and a vibrant community pool. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Columbia, SC",
  "property_seo_description_gallery": "Picture your dream life at Ashcroft in Columbia, SC. Spacious 3- and 4-bedroom apartments with modern amenities await. See your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Ashcroft Apartments",
  "property_seo_description_virtualtours": "Experience Ashcroft in Columbia, SC! Take a virtual tour of our spacious three and four-bedroom apartments, where comfort meets style. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Ashcroft Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Ashcroft in Columbia, SC! Use our interactive map to explore spacious three- and four-bedroom apartments with luxury amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Columbia, SC",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood around Ashcroft in Columbia, SC. From local favorites to intriguing spots, see what makes our community special!",
  "property_seo_title_contact": "Contact Us | Ashcroft",
  "property_seo_description_contact": "Connect with Ashcroft in Columbia, SC! Whether you're interested in our spacious three- or four-bedroom floor plans, our leasing team is here to help.",
  "property_seo_title_faqs": "FAQs | Apartments in Columbia, SC",
  "property_seo_description_faqs": "Get answers about Ashcroft in Columbia, SC! Explore our FAQs on spacious floor plans, luxury amenities, and smart living convenience. Your ideal home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Columbia, SC",
  "property_seo_description_reviews": "Uncover the Ashcroft difference in Columbia, SC! From luxurious amenities to spacious floor plans, see what our residents love about their home sweet home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Columbia, SC",
  "property_seo_description_applynow": "Experience luxury living at Ashcroft in Columbia, SC. Choose from 3- or 4-bedroom apartments with modern amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Ashcroft",
  "property_seo_description_residentaccess": "Unlock the Ashcroft resident portal for seamless rent payments, maintenance requests, and community updates. Elevate your living experience in Columbia, SC!",
  "property_seo_title_referafriend": "Refer A Friend | Ashcroft",
  "property_seo_description_referafriend": "Refer a friend to Ashcroft in Columbia, SC, where great friends turn into great neighbors! Share the joy of living in our vibrant apartment community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Ashcroft",
  "property_seo_description_scheduletour": "Experience Ashcroft in Columbia, SC! Embrace vibrant living, picturesque views, and modern amenities. Schedule a tour and see your future home today!",
  "property_seo_title_privacy": "Privacy Policy | Ashcroft",
  "property_seo_description_privacy": "At Ashcroft in Columbia, SC, your privacy matters. Discover how we secure your personal information. Learn more today!",
  "property_seo_title_accessibility": "Website Accessibility | Ashcroft",
  "property_seo_description_accessibility": "At Ashcroft in Columbia, SC, we prioritize digital inclusion. Our commitment ensures everyone can access our community resources with ease. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Ashcroft",
  "property_seo_description_sitemap": "Navigate your way to your perfect home at Ashcroft in Columbia, SC! Browse our sitemap for easy access to amenities, floor plans, and leasing info.",
  "property_seo_title_thankyou": "Thank You | Ashcroft",
  "property_seo_description_thankyou": "Thank you for reaching out to Ashcroft in Columbia, SC! Our team is excited to connect soon and help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Columbia, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793286730395",
  "amenities": [
    {
      "id": "ec_c09b3eeb3eae17d526315bc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203644",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16f94cd968ad51fbb59a61d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203641",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81052f76bf33c625e15e5edf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203650",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1c56a11e16d42f14c0ce1b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203649",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c184754bc242f00d383c0b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203648",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98960f27bd30249bf169a71f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203647",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44aa22ce0d9c2610b3a7ff8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203646",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e4b6befc8eb56c6fb193952",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "122203645",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e230f6ed80b058cda423e962",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "129173087",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_a2bbb8b79daacb51fa75fd7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-454d-759d-bc2b-d8b9997c6743.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
        "public_id": "01a188e7-454d-759d-bc2b-d8b9997c6743",
        "storage_key": "property/6767906449167635/01a188e7-454d-759d-bc2b-d8b9997c6743.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Apartment",
      "description": "Explore the spacious and modern kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and ample white cabinetry for all your storage needs.",
      "link": "false",
      "alt_text": "kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-foxglove-kitchen-2(1).jpg"
    },
    {
      "id": "ec_adbef26d2717d84377939171",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-3a9e-72bd-bfeb-e1328b9aad84.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with a blue upper story and a stone-accented lower story, featuring a white garage door and a black front door with the number 1111.",
        "public_id": "019fec2b-3a9e-72bd-bfeb-e1328b9aad84",
        "storage_key": "property/6767906449167635/019fec2b-3a9e-72bd-bfeb-e1328b9aad84.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Showcasing the charming exterior of a two-story home, complete with a welcoming front entrance, a spacious two-car garage, and attractive architectural details.",
      "link": "false",
      "alt_text": "A two-story house with a garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-townsend.jpg"
    },
    {
      "id": "ec_ea42077d7600d9f133afe39e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-4ae6-705e-bc09-dabff6c4a1d0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with surrounding townhomes.",
        "public_id": "019fec2b-4ae6-705e-bc09-dabff6c4a1d0",
        "storage_key": "property/6767906449167635/019fec2b-4ae6-705e-bc09-dabff6c4a1d0.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and the beautiful community.",
      "link": "false",
      "alt_text": "A large swimming pool surrounded by lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Pool-1.jpg"
    },
    {
      "id": "ec_97e40beb075b8cde2cf050f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-7504-7019-aae2-b3cfbc3d207b.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and manicured lawns.",
        "public_id": "019fec2b-7504-7019-aae2-b3cfbc3d207b",
        "storage_key": "property/6767906449167635/019fec2b-7504-7019-aae2-b3cfbc3d207b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Experience modern living in this sprawling residential community, featuring thoughtfully designed homes and beautiful green spaces.",
      "link": "false",
      "alt_text": "an aerial view of a neighborhood with houses and cars parked",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Aerial-June-2024-(2).jpg"
    },
    {
      "id": "ec_e4f967ffc0fb6126b0b43c61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-4c8c-72ff-8ee9-955dac6abb5f.webp",
      "image_media": {
        "alt_text": "Ashcroft monument sign",
        "public_id": "019fec2b-4c8c-72ff-8ee9-955dac6abb5f",
        "storage_key": "property/6767906449167635/019fec2b-4c8c-72ff-8ee9-955dac6abb5f.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Welcome to Ashcroft, a premier community with beautiful landscaping and elegant monument signage.",
      "link": "false",
      "alt_text": "A stone wall with the name \"ASHCROFT\" on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Monument-Sign.jpg"
    },
    {
      "id": "ec_2f9ba5988db564435d460a8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-4a22-7368-9a2e-1a84c1cf59ec.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019fec2b-4a22-7368-9a2e-1a84c1cf59ec",
        "storage_key": "property/6767906449167635/019fec2b-4a22-7368-9a2e-1a84c1cf59ec.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious and bright kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "false",
      "alt_text": "A modern kitchen with white cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-townsend-kitchen.jpg"
    },
    {
      "id": "ec_066254027aeb5a0f4a6092ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-5737-753a-b01b-ceaeab8cbb1e.webp",
      "image_media": {
        "alt_text": "Double vanity with white countertops and sinks, walk-in closet and toilet",
        "public_id": "019fec2b-5737-753a-b01b-ceaeab8cbb1e",
        "storage_key": "property/6767906449167635/019fec2b-5737-753a-b01b-ceaeab8cbb1e.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious bathroom with a double vanity, ample closet space, and a separate toilet area.",
      "link": "false",
      "alt_text": "A bathroom with a sink, toilet, and a mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-townsend-bath.jpg"
    },
    {
      "id": "ec_b44d65b6f57d40e0a857173c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-5dd2-76f3-8557-d9726caa9651.webp",
      "image_media": {
        "alt_text": "Aerial view of a street with multiple townhouses and single-family homes on a sunny day.",
        "public_id": "01a188e7-5dd2-76f3-8557-d9726caa9651",
        "storage_key": "property/6767906449167635/01a188e7-5dd2-76f3-8557-d9726caa9651.webp",
        "width": 2929,
        "height": 2106
      },
      "title": "Community",
      "description": "Discover this charming neighborhood with beautifully designed townhouses and single-family homes, offering a peaceful and picturesque living environment.",
      "link": "false",
      "alt_text": "A residential street with houses on both sides and a clear sky above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Aerial-Homes%20(3).jpg"
    },
    {
      "id": "ec_8cc691efb71bd0d0b83a33a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-5cf9-7676-bfb6-271629b9d922.webp",
      "image_media": {
        "alt_text": "Aerial view of a neighborhood with townhouses and single-family homes.",
        "public_id": "01a188e7-5cf9-7676-bfb6-271629b9d922",
        "storage_key": "property/6767906449167635/01a188e7-5cf9-7676-bfb6-271629b9d922.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Discover this beautiful new construction neighborhood featuring modern townhomes and single-family residences, offering a charming community atmosphere.",
      "link": "false",
      "alt_text": "an aerial view of a neighborhood with houses and cars parked",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Aerial%20(3).jpg"
    },
    {
      "id": "ec_2270aa59e5b329ceea47bfb9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-5bb6-777b-98ba-506b7b9f9089.webp",
      "image_media": {
        "alt_text": "Exterior of a modern white building with a gray metal roof and landscaping.",
        "public_id": "01a188e7-5bb6-777b-98ba-506b7b9f9089",
        "storage_key": "property/6767906449167635/01a188e7-5bb6-777b-98ba-506b7b9f9089.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Modern exterior of the community building with a welcoming entrance and lush green surroundings.",
      "link": "false",
      "alt_text": "clubhouse",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Clubhouse-1.jpg"
    },
    {
      "id": "ec_830eb97427cf2cb5f2023549",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-5b7b-75c7-951b-d857ded63727.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with wood-look flooring and white cabinets",
        "public_id": "01a188e7-5b7b-75c7-951b-d857ded63727",
        "storage_key": "property/6767906449167635/01a188e7-5b7b-75c7-951b-d857ded63727.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious living area and modern kitchen featuring wood-look flooring, white cabinets, granite countertops, and a breakfast bar.",
      "link": "false",
      "alt_text": "kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-dixon-living(1).jpg"
    },
    {
      "id": "ec_f4a07a6c0cb4d91568a5a837",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-5b74-7358-9275-a76382a25d0c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with wood-look flooring and white cabinets.",
        "public_id": "01a188e7-5b74-7358-9275-a76382a25d0c",
        "storage_key": "property/6767906449167635/01a188e7-5b74-7358-9275-a76382a25d0c.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a modern kitchen featuring white cabinetry and a breakfast bar with granite countertops. Enjoy an open-concept layout perfect for entertaining.",
      "link": "false",
      "alt_text": "kitchen island and refrigerator",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-underwood-living(1).jpg"
    },
    {
      "id": "ec_6595ac2d734a2bf25f08d7e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-678a-778c-9f90-1bd20720105a.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story home with a two-car garage, light beige and gray siding, and a black front door.",
        "public_id": "01a188e7-678a-778c-9f90-1bd20720105a",
        "storage_key": "property/6767906449167635/01a188e7-678a-778c-9f90-1bd20720105a.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Charming two-story home featuring a spacious two-car garage, beautiful gray and light beige siding, and a welcoming black front door.",
      "link": "false",
      "alt_text": "Two-story home with garage",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-dixon(1).jpg"
    },
    {
      "id": "ec_c35607cdf703d44927e57ba8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-695b-71d0-8f28-f1096621c926.webp",
      "image_media": {
        "alt_text": "Street view of modern townhomes with parked cars and a street sign that reads Larkner Ln.",
        "public_id": "01a188e7-695b-71d0-8f28-f1096621c926",
        "storage_key": "property/6767906449167635/01a188e7-695b-71d0-8f28-f1096621c926.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "A street view of a modern townhome community, showcasing the architecture and ample parking. The street sign indicates Larkner Ln.",
      "link": "false",
      "alt_text": "row of homes",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-aerial-homes.jpg"
    },
    {
      "id": "ec_5b2eb38deefce1fd8a491406",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-6ab9-7461-aa68-1083f8a320b9.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property featuring a pool and surrounding townhouses.",
        "public_id": "01a188e7-6ab9-7461-aa68-1083f8a320b9",
        "storage_key": "property/6767906449167635/01a188e7-6ab9-7461-aa68-1083f8a320b9.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover resort-style living with our sparkling pool and well-maintained community spaces, surrounded by beautiful townhome residences.",
      "link": "false",
      "alt_text": "clubhouse and pool",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Clubhouse-2.jpg"
    },
    {
      "id": "ec_8fa646651d269f750cda7ce5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-6f63-716e-8b2c-e56d4f79dc7e.webp",
      "image_media": {
        "alt_text": "Exterior of a modern multifamily townhouse property with garages and front doors.",
        "public_id": "01a188e7-6f63-716e-8b2c-e56d4f79dc7e",
        "storage_key": "property/6767906449167635/01a188e7-6f63-716e-8b2c-e56d4f79dc7e.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Beautiful exterior of a multifamily property showcasing modern townhome architecture with clean lines, spacious garages, and welcoming entrances.",
      "link": "false",
      "alt_text": "A white house with a black roof and two garages.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-dahlia(1).jpg"
    },
    {
      "id": "ec_5a44cbc5b5eb153ac8c7ccae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-7327-75b0-9c3f-48f104be31f6.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with townhouses and single-family homes.",
        "public_id": "01a188e7-7327-75b0-9c3f-48f104be31f6",
        "storage_key": "property/6767906449167635/01a188e7-7327-75b0-9c3f-48f104be31f6.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Discover charming townhouses and spacious single-family homes in this picturesque suburban neighborhood. Enjoy a peaceful community with beautiful streetscapes.",
      "link": "false",
      "alt_text": "an aerial view of the neighborhood",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Aerial%20(2).jpg"
    },
    {
      "id": "ec_d65f5c9c9bf62f04fcc5284c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-7325-722a-8c51-7e76fbdebcfb.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower. Includes a walk-in closet.",
        "public_id": "01a188e7-7325-722a-8c51-7e76fbdebcfb",
        "storage_key": "property/6767906449167635/01a188e7-7325-722a-8c51-7e76fbdebcfb.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a double vanity, toilet, and a glass-enclosed shower. A spacious walk-in closet is accessible through an adjacent doorway.",
      "link": "false",
      "alt_text": "bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-dixon-bath(1).jpg"
    },
    {
      "id": "ec_90ddb5665929c05f70576693",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-765f-7342-a157-c06fc4472c31.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with white siding and brown accents.",
        "public_id": "01a188e7-765f-7342-a157-c06fc4472c31",
        "storage_key": "property/6767906449167635/01a188e7-765f-7342-a157-c06fc4472c31.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Modern townhome exteriors featuring white siding, brown gable accents, and black awnings over the front doors.",
      "link": "false",
      "alt_text": "row of homes",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Aerial-Homes%20(2).jpg"
    },
    {
      "id": "ec_a0dcc78a08ab1a15a8898869",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-791d-716b-bd44-a0d6a55a179c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry",
        "public_id": "01a188e7-791d-716b-bd44-a0d6a55a179c",
        "storage_key": "property/6767906449167635/01a188e7-791d-716b-bd44-a0d6a55a179c.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed kitchen, complete with sleek stainless steel appliances, ample white cabinetry, and granite countertops.",
      "link": "false",
      "alt_text": "kitchen with oven",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-dixon-kitchen(1).jpg"
    },
    {
      "id": "ec_5a1f0f88c432a7ed9b5adaef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-7b07-754e-8642-c1af97e55072.webp",
      "image_media": {
        "alt_text": "Exterior of two townhomes with attached garages and dark front doors.",
        "public_id": "01a188e7-7b07-754e-8642-c1af97e55072",
        "storage_key": "property/6767906449167635/01a188e7-7b07-754e-8642-c1af97e55072.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Exterior view of two adjacent townhomes, each featuring a garage, prominent windows, and a welcoming front entrance.",
      "link": "false",
      "alt_text": "front of home",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-foxglove(1).jpg"
    },
    {
      "id": "ec_cff3951a391057abd5549beb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-7f2c-76ef-aa6a-ff54e6d652d2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a188e7-7f2c-76ef-aa6a-ff54e6d652d2",
        "storage_key": "property/6767906449167635/01a188e7-7f2c-76ef-aa6a-ff54e6d652d2.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, stainless steel appliances, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-dahlia-kitchen(1).jpg"
    },
    {
      "id": "ec_9e29bc6a76a861190ef0f072",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-80b3-7657-979e-8a21dc7e4a95.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of modern houses and manicured lawns.",
        "public_id": "01a188e7-80b3-7657-979e-8a21dc7e4a95",
        "storage_key": "property/6767906449167635/01a188e7-80b3-7657-979e-8a21dc7e4a95.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Community",
      "description": "Discover a charming suburban community featuring an array of beautifully designed homes, perfect for modern living.",
      "link": "false",
      "alt_text": "rows of homes",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-Aerial%20(1).jpg"
    },
    {
      "id": "ec_34a19d221290d06e8083eeea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/01a188e7-83ea-74ce-88cd-e428c882f7ca.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with an island and sliding glass doors.",
        "public_id": "01a188e7-83ea-74ce-88cd-e428c882f7ca",
        "storage_key": "property/6767906449167635/01a188e7-83ea-74ce-88cd-e428c882f7ca.webp",
        "width": 1280,
        "height": 920
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area, featuring a modern kitchen with an island, granite countertops, stainless steel appliances, and direct access to an outdoor patio.",
      "link": "false",
      "alt_text": "kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Ashcroft-dahlia-living(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_17ff65fa-b900-4883-bd7b-e0263f49c4b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Groucho's Deli",
      "poi_type": "Restaurants",
      "poi_address": "111 Sparkleberry Crossing Rd #8, Columbia, SC 29229, USA",
      "poi_short_description": "Chain restaurant known for classic deli sandwiches & signature sides such as potato salad.",
      "poi_long_description": "Chain restaurant known for classic deli sandwiches & signature sides such as potato salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-9013-7769-a98a-5b758e812b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-9013-7769-a98a-5b758e812b53",
        "storage_key": "property/6767906449167635/019fec2d-9013-7769-a98a-5b758e812b53.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://locations.grouchos.com/locations/sc/columbia/111-sparkleberry-crossing-suite-8",
      "poi_directions_map_url": "https://maps.google.com/?cid=7399276866923807620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grouchos-deli",
      "poi_latitude": "34.1016828",
      "poi_longitude": "-80.8552837",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-419-6767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c88-716d-b59c-040d4d317a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c88-716d-b59c-040d4d317a1f",
        "storage_key": "property/6767906449167635/019fec2a-4c88-716d-b59c-040d4d317a1f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2_m6C8-r-IgRhEPCfxuDr2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_d38e2bc4-53a9-4b78-83f0-9f2003d8d3d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Tokyo Grill",
      "poi_type": "Restaurants",
      "poi_address": "111 Sparkleberry Crossing Rd Suite 9, Columbia, SC 29229, USA",
      "poi_short_description": "Counter-serve restaurant chain with hibachi & teriyaki meats, plus sushi, salads & Japanese sides.",
      "poi_long_description": "Counter-serve restaurant chain with hibachi & teriyaki meats, plus sushi, salads & Japanese sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-91f1-779f-bd86-775cb27b4bfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-91f1-779f-bd86-775cb27b4bfb",
        "storage_key": "property/6767906449167635/019fec2d-91f1-779f-bd86-775cb27b4bfb.webp",
        "width": 720,
        "height": 565
      },
      "poi_business_url": "https://www.tokyogrill.com/locations/tokyo-grill-columbia-2?utm_source=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=5158585990173455929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tokyo-grill",
      "poi_latitude": "34.1016422",
      "poi_longitude": "-80.85535159999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-788-7288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2_m6C8-r-IgROXaYb6D6lkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_27c1b3f3-f3a4-4d0e-aec0-e3d274c0b15e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Henry's Northeast",
      "poi_type": "Restaurants",
      "poi_address": "111 Sparkleberry Crossing Rd #1, Columbia, SC 29229, USA",
      "poi_short_description": "Relaxed minichain pub with a pool table offering American comfort grub & a standard range of drinks.",
      "poi_long_description": "Relaxed minichain pub with a pool table offering American comfort grub & a standard range of drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-94a8-76b0-a3f4-63f3b4596216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-94a8-76b0-a3f4-63f3b4596216",
        "storage_key": "property/6767906449167635/019fec2d-94a8-76b0-a3f4-63f3b4596216.webp",
        "width": 1089,
        "height": 1280
      },
      "poi_business_url": "http://www.henrysgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3932936987189242336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henrys-northeast",
      "poi_latitude": "34.1015778",
      "poi_longitude": "-80.8558656",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 803-563-5674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYKjC8-r-IgR4OloLVqZlDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_4970f99a-bad9-4794-88a5-94b0998740fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Julia's German Stammtisch",
      "poi_type": "Restaurants",
      "poi_address": "120 Sparkleberry Crossing Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Schnitzel & other German classics, plus seasonal tortes, served in a casual, cash-only restaurant.",
      "poi_long_description": "Schnitzel & other German classics, plus seasonal tortes, served in a casual, cash-only restaurant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-9ceb-72c8-a734-84798fd2d6d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-9ceb-72c8-a734-84798fd2d6d8",
        "storage_key": "property/6767906449167635/019fec2d-9ceb-72c8-a734-84798fd2d6d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://julias-german-stammtisch.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=202555016542569769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julias-german-stammtisch",
      "poi_latitude": "34.1003493",
      "poi_longitude": "-80.8550556",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 803-738-0630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVwAGhuw-IgRKUV-4LaezwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "german_restaurant"
    },
    {
      "id": "custom_b1e60589-1d6b-42ac-9a9e-15f915d2d8dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Cocos & Beer Authentic Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "841 Sparkleberry Ln Unit 4, Columbia, SC 29229, USA",
      "poi_short_description": "Low-key Mexican spot with outdoor seating offering margaritas and burritos, plus friendly service.",
      "poi_long_description": "Low-key Mexican spot with outdoor seating offering margaritas and burritos, plus friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-95d9-75cf-9438-c60f49cd16ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-95d9-75cf-9438-c60f49cd16ca",
        "storage_key": "property/6767906449167635/019fec2d-95d9-75cf-9438-c60f49cd16ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3397430579739310166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cocos--beer-authentic-mexican-restaurant",
      "poi_latitude": "34.1001078",
      "poi_longitude": "-80.856206",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-888-6914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9_G4Dar-IgRVjhpphwZJi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3d9dd45c-e5cc-49de-99ae-b01ff59078c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "10136 Two Notch Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-bf45-74cb-8605-455717595fba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-bf45-74cb-8605-455717595fba",
        "storage_key": "property/6767906449167635/019fec2d-bf45-74cb-8605-455717595fba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.chipotle.com/sc/columbia/10136-two-notch-rd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=3313",
      "poi_directions_map_url": "https://maps.google.com/?cid=15248648676245172685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "34.1168765",
      "poi_longitude": "-80.88228889999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-753-1055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdfAy0Gr-IgRzfFSJC4VntM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_83491cd6-dd96-47d5-8eec-87a54f8c5651",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Menkoi Ramen House in the Village at Sandhill",
      "poi_type": "Restaurants",
      "poi_address": "493-1 Town Center Pl, Columbia, SC 29229, USA",
      "poi_short_description": "Ramen restaurant in the Village at Sandhill shopping district.",
      "poi_long_description": "Ramen restaurant in the Village at Sandhill shopping district.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-9060-715e-8019-749f5c946f73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-9060-715e-8019-749f5c946f73",
        "storage_key": "property/6767906449167635/019fec2d-9060-715e-8019-749f5c946f73.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://menkoiramenhouse.com/menkoivillageatsandhill?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9861251061907999075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menkoi-ramen-house-in-the-village-at-sandhill",
      "poi_latitude": "34.1276964",
      "poi_longitude": "-80.8775525",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-828-3908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyi9Wlyr-IgRY0n4-Zcz2og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_bd8e8257-9464-4fe4-a1a8-d211642ec34f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Red Bowl Asian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "481-11 Town Center Pl, Columbia, SC 29229, USA",
      "poi_short_description": "Contemporary eatery offering Chinese, Japanese, Thai & Vietnamese food, with customizable options.",
      "poi_long_description": "Contemporary eatery offering Chinese, Japanese, Thai & Vietnamese food, with customizable options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-9d47-777e-bfe2-00a0849f7c28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-9d47-777e-bfe2-00a0849f7c28",
        "storage_key": "property/6767906449167635/019fec2d-9d47-777e-bfe2-00a0849f7c28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.redbowlcolumbia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16948669512058168694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-bowl-asian-bistro",
      "poi_latitude": "34.129141",
      "poi_longitude": "-80.87816300000001",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-462-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRZGkDaq-IgRdmW4kR_FNes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_9a51f7ea-87a6-4a20-aa49-05eea98aedaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Blue Fin Restaurant And Bar",
      "poi_type": "Restaurants",
      "poi_address": "461-4 Town Center Pl, Columbia, SC 29229, USA",
      "poi_short_description": "Modern, refined eatery presenting seafood dishes, steak & cocktails plus happy hour & brunch.",
      "poi_long_description": "Modern, refined eatery presenting seafood dishes, steak & cocktails plus happy hour & brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-a7dd-74ba-9143-c47d0e856022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-a7dd-74ba-9143-c47d0e856022",
        "storage_key": "property/6767906449167635/019fec2d-a7dd-74ba-9143-c47d0e856022.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://bluefinrestaurantandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1817704981902093034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-fin-restaurant-and-bar",
      "poi_latitude": "34.1307363",
      "poi_longitude": "-80.87933029999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-865-7346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRZGkDaq-IgR6mq76AzJORk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_0a015477-c930-461a-9753-f894b63049e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Le Peep",
      "poi_type": "Restaurants",
      "poi_address": "110 Forum Dr Ste 7, Columbia, SC 29229, USA",
      "poi_short_description": "Casual breakfast & lunch chain with a long menu of straightforward fare & coffee drinks.",
      "poi_long_description": "Casual breakfast & lunch chain with a long menu of straightforward fare & coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-a83c-74ac-9467-bde38bbc4643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-a83c-74ac-9467-bde38bbc4643",
        "storage_key": "property/6767906449167635/019fec2d-a83c-74ac-9467-bde38bbc4643.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lepeep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13238623523160978573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "le-peep",
      "poi_latitude": "34.1341448",
      "poi_longitude": "-80.8820207",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-550-9685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9qm9kmq-IgRjfQj_fMJubc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5e9190bf-3690-49a3-8c31-4b524a5cb9d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Travinia Italian Kitchen & Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "101 Sparkleberry Crossing Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Inviting outpost of a local chain for Italian classics with a modern twist & an extensive wine menu.",
      "poi_long_description": "Inviting outpost of a local chain for Italian classics with a modern twist & an extensive wine menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-9c94-769f-8d5b-d44f05ded661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-9c94-769f-8d5b-d44f05ded661",
        "storage_key": "property/6767906449167635/019fec2d-9c94-769f-8d5b-d44f05ded661.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.traviniacolumbia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5811236469825243147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "travinia-italian-kitchen--wine-bar",
      "poi_latitude": "34.1014586",
      "poi_longitude": "-80.8566019",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-419-9313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c91-712f-a5a3-aeeadebf3aeb",
        "storage_key": "property/6767906449167635/019fec2a-4c91-712f-a5a3-aeeadebf3aeb.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI15kqM-r-IgRC4i6sceopVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b73b23c0-a348-4128-902f-d4003e2cb7ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 Summit Pkwy, Columbia, SC 29229, USA",
      "poi_short_description": "Grocery chain offering a mix of private-label items and name brands, plus a bakery.",
      "poi_long_description": "Grocery chain offering a mix of private-label items and name brands, plus a bakery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-b9d0-7772-9867-d76f6f7784e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-b9d0-7772-9867-d76f6f7784e0",
        "storage_key": "property/6767906449167635/019fec2d-b9d0-7772-9867-d76f6f7784e0.webp",
        "width": 1280,
        "height": 731
      },
      "poi_business_url": "http://www.lidl.com/s/en-US/stores/columbia/summit-parkway-1401/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17827892313668142313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "34.15793439999999",
      "poi_longitude": "-80.9092852",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c88-716d-b59c-0f6d019c1b6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c88-716d-b59c-0f6d019c1b6c",
        "storage_key": "property/6767906449167635/019fec2a-4c88-716d-b59c-0f6d019c1b6c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5U_BeS-p-IgR6UQbYpplafc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5c42e9b5-0bad-4d89-b633-05ececb02f48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Publix Super Market at Rice Creek Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "4611 Hard Scrabble Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-2c80-730b-83c3-2c34595fda7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2a-2c80-730b-83c3-2c34595fda7b",
        "storage_key": "property/6767906449167635/019fec2a-2c80-730b-83c3-2c34595fda7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=829&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=17332091309447657669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-rice-creek-village",
      "poi_latitude": "34.1533237",
      "poi_longitude": "-80.9131668",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-699-8131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c88-716d-b59c-0f6d019c1b6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c88-716d-b59c-0f6d019c1b6c",
        "storage_key": "property/6767906449167635/019fec2a-4c88-716d-b59c-0f6d019c1b6c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd5E7x-2p-IgRxThDcjf1h_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_fd48f12b-72b4-41fc-9a4b-e5c79666fc66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1051 Sams Crossing Dr, Columbia, SC 29229, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-31e7-720b-9b58-4a6de174c92f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2a-31e7-720b-9b58-4a6de174c92f",
        "storage_key": "property/6767906449167635/019fec2a-31e7-720b-9b58-4a6de174c92f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/SC-Columbia/3026?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-3026-_-na-_-0-_-0&y_source=1_MTE4NDA2Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5691800436714357389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "34.137084",
      "poi_longitude": "-80.94206199999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 803-476-1320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c88-716d-b59c-040d4d317a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c88-716d-b59c-040d4d317a1f",
        "storage_key": "property/6767906449167635/019fec2a-4c88-716d-b59c-040d4d317a1f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJad3S2qyp-IgRjcLFOldW_U4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_1e01c8dc-7ff9-429c-b74f-37a514a4a7f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Landy's Pharmacy & Gifts",
      "poi_type": "Health and Wellness",
      "poi_address": "835 Sparkleberry Ln, Columbia, SC 29229, USA",
      "poi_short_description": "Independent pharmacy and gift shop on Sparkleberry Lane.",
      "poi_long_description": "Independent pharmacy and gift shop on Sparkleberry Lane.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-e859-722d-9604-291f8e7d98ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-e859-722d-9604-291f8e7d98ad",
        "storage_key": "property/6767906449167635/019fec2d-e859-722d-9604-291f8e7d98ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.landyspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2497963681299558103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "landys-pharmacy--gifts",
      "poi_latitude": "34.1006634",
      "poi_longitude": "-80.8563376",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 803-567-3107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2e-0c34-7777-92e2-36c28fd649c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-0c34-7777-92e2-36c28fd649c2",
        "storage_key": "property/6767906449167635/019fec2e-0c34-7777-92e2-36c28fd649c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvWk8tp-r-IgR1-6vvbuMqiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_09ef7f19-b363-4c34-a1d7-5a436ae5c165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "HCA CareNow - Spring Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "10136 Two Notch Rd Ste 104, Columbia, SC 29229, USA",
      "poi_short_description": "Walk-in urgent care clinic on Two Notch Road.",
      "poi_long_description": "Walk-in urgent care clinic on Two Notch Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-e596-739f-80cb-7d1cd8316542.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-e596-739f-80cb-7d1cd8316542",
        "storage_key": "property/6767906449167635/019fec2d-e596-739f-80cb-7d1cd8316542.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.carenow.com/locations/columbia/spring-valley?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=697387384673739981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-carenow---spring-valley",
      "poi_latitude": "34.1165917",
      "poi_longitude": "-80.88298979999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-509-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c7e-731d-952f-54394af04938",
        "storage_key": "property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT2fhLsmr-IgRzSRRpiGerQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_5f09d7ca-42e2-4bd4-a289-29d18f45eb56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2110 Clemson Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Chain gym with a variety of workout equipment, tanning beds, and spa services, plus a welcoming staff.",
      "poi_long_description": "Chain gym with a variety of workout equipment, tanning beds, and spa services, plus a welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-35d4-7638-a79c-33d385757716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2a-35d4-7638-a79c-33d385757716",
        "storage_key": "property/6767906449167635/019fec2a-35d4-7638-a79c-33d385757716.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/columbia-clemson-rd-sc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1901934684248328091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.140672",
      "poi_longitude": "-80.915048",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-667-9805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c7e-731d-952f-54394af04938",
        "storage_key": "property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTcqoID-p-IgRm8eduIQHZRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0aa1a5ba-16bf-4635-ad7b-bedd43a8f2e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "4520 Hard Scrabble Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-c979-7433-b272-d38f4500fa29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-c979-7433-b272-d38f4500fa29",
        "storage_key": "property/6767906449167635/019fec2d-c979-7433-b272-d38f4500fa29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4520+hard+scrabble+rd-columbia-sc-29229/id=12677",
      "poi_directions_map_url": "https://maps.google.com/?cid=17889764577612334965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.14813",
      "poi_longitude": "-80.9103772",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-419-7507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c7e-731d-952f-54394af04938",
        "storage_key": "property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeeFipKp-IgRdQfzaxk2Rfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_9956b397-b9a5-4011-a01b-ab27f2613a13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "MUSC Health Columbia Medical Center Northeast",
      "poi_type": "Health and Wellness",
      "poi_address": "120 Gateway Corporate Blvd, Columbia, SC 29203, USA",
      "poi_short_description": "Hospital and medical center serving Northeast Columbia.",
      "poi_long_description": "Hospital and medical center serving Northeast Columbia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-e737-764c-892e-2f95a903e1ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-e737-764c-892e-2f95a903e1ea",
        "storage_key": "property/6767906449167635/019fec2d-e737-764c-892e-2f95a903e1ea.webp",
        "width": 1280,
        "height": 667
      },
      "poi_business_url": "https://www.getcare.muschealth.org/locations/sc/columbia/musc-health-columbia-medical-center-northeastdep-fac639?y_source=1_MjUwNjY2NDAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14073551792164650367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "musc-health-columbia-medical-center-northeast",
      "poi_latitude": "34.1039225",
      "poi_longitude": "-80.9583358",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-865-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c87-743c-97a9-0abb0f2c9b05.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c87-743c-97a9-0abb0f2c9b05",
        "storage_key": "property/6767906449167635/019fec2a-4c87-743c-97a9-0abb0f2c9b05.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQTtPsOo-IgRfz0JRMpMT8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_2f66f6c0-9509-40b4-92fe-cadeb821704d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Spring Valley High School",
      "poi_type": "Education",
      "poi_address": "120 Sparkleberry Ln, Columbia, SC 29229, USA",
      "poi_short_description": "Public high school, Richland School District Two.",
      "poi_long_description": "Public high school, Richland School District Two.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-d157-756e-8b6d-d720ffd3ece0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-d157-756e-8b6d-d720ffd3ece0",
        "storage_key": "property/6767906449167635/019fec2d-d157-756e-8b6d-d720ffd3ece0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.svh.richland2.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1490104437536993993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-valley-high-school",
      "poi_latitude": "34.1109545",
      "poi_longitude": "-80.883067",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-699-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c93-704d-8a7c-680eb0e624a8",
        "storage_key": "property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt3yraM-r-IgRyTKgTRfqrRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3d87c3a0-7f99-4231-a937-96ef7449988f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "North Springs Elementary School",
      "poi_type": "Education",
      "poi_address": "1300 Clemson Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Public elementary school, Richland School District Two.",
      "poi_long_description": "Public elementary school, Richland School District Two.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-cd09-74b7-b9ec-95a1f3e171ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-cd09-74b7-b9ec-95a1f3e171ad",
        "storage_key": "property/6767906449167635/019fec2d-cd09-74b7-b9ec-95a1f3e171ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nse.richland2.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14629091280701550484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-springs-elementary-school",
      "poi_latitude": "34.1415683",
      "poi_longitude": "-80.8861593",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-736-3183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c93-704d-8a7c-680eb0e624a8",
        "storage_key": "property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl3VVZzuq-IgRlO_69AL5BMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f0c38654-cc73-44ac-9811-3c1d6ee33e13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Summit Parkway Middle School",
      "poi_type": "Education",
      "poi_address": "200 Summit Pkwy, Columbia, SC 29229, USA",
      "poi_short_description": "Public middle school, Richland School District Two.",
      "poi_long_description": "Public middle school, Richland School District Two.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.spm.richland2.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4121625384020659443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summit-parkway-middle-school",
      "poi_latitude": "34.1430699",
      "poi_longitude": "-80.8822162",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-699-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c93-704d-8a7c-680eb0e624a8",
        "storage_key": "property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ29BgKTir-IgR88zID3P0Mjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b642223a-126e-4357-b428-fa6441f7c39f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Midlands Technical College - Northeast Campus",
      "poi_type": "Education",
      "poi_address": "151 Powell Rd, Columbia, SC 29203, USA",
      "poi_short_description": "Two-year technical college campus on Powell Road.",
      "poi_long_description": "Two-year technical college campus on Powell Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-d64c-777f-8aff-3eadf1372fdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-d64c-777f-8aff-3eadf1372fdb",
        "storage_key": "property/6767906449167635/019fec2d-d64c-777f-8aff-3eadf1372fdb.webp",
        "width": 1280,
        "height": 615
      },
      "poi_business_url": "https://www.midlandstech.edu/?utm_source=google&utm_medium=organic&utm_campaign=gbp_northeast_campus&utm_content=profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=8755886176466719002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midlands-technical-college---northeast-campus",
      "poi_latitude": "34.098381",
      "poi_longitude": "-80.97243499999999",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-738-8324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c93-704d-8a7c-680eb0e624a8",
        "storage_key": "property/6767906449167635/019fec2a-4c93-704d-8a7c-680eb0e624a8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJid71nLCo-IgRGlENOhYog3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b187cd9e-a13e-469c-a28e-9b813019a54a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Regal Sandhill",
      "poi_type": "Entertainment",
      "poi_address": "450 Town Center Pl, Columbia, SC 29229, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-d725-75df-a188-95b0b1d4e259.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-d725-75df-a188-95b0b1d4e259",
        "storage_key": "property/6767906449167635/019fec2d-d725-75df-a188-95b0b1d4e259.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-sandhill-1855?utm_campaign=gmb-listing&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4115867517535727719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-sandhill",
      "poi_latitude": "34.131077",
      "poi_longitude": "-80.88024",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2e-0c34-7777-92e2-324c20734c26.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-0c34-7777-92e2-324c20734c26",
        "storage_key": "property/6767906449167635/019fec2e-0c34-7777-92e2-324c20734c26.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaJokDaq-IgRZzBJTbN_Hjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3abca464-54bf-4b23-a52a-e719e078a034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Columbia Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1515 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Paintings & sculptures spanning thousands of years, displayed in a contemporary building.",
      "poi_long_description": "Paintings & sculptures spanning thousands of years, displayed in a contemporary building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-dd05-72e9-b4ad-34d9c8286a56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-dd05-72e9-b4ad-34d9c8286a56",
        "storage_key": "property/6767906449167635/019fec2d-dd05-72e9-b4ad-34d9c8286a56.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://www.columbiamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17573773874273889936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-museum-of-art",
      "poi_latitude": "34.0058172",
      "poi_longitude": "-81.0362938",
      "poi_miles_from_property": "14.6 mi",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 803-799-2810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2e-0c3e-72a9-99a4-8210c079bcbd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-0c3e-72a9-99a4-8210c079bcbd",
        "storage_key": "property/6767906449167635/019fec2e-0c3e-72a9-99a4-8210c079bcbd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJca7xktSk-IgRkK4ikzqW4vM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_77257dd7-1a5a-4e5a-8ad4-0be36c58c8cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Riverbanks Zoo & Garden",
      "poi_type": "Entertainment",
      "poi_address": "500 Wildlife Pkwy, Columbia, SC 29210, USA",
      "poi_short_description": "Zoo with African & Australian animals, reptile galleries, a bird house, a farm & botanical gardens.",
      "poi_long_description": "Zoo with African & Australian animals, reptile galleries, a bird house, a farm & botanical gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-da3b-74fb-b3f5-2e6c51596b3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-da3b-74fb-b3f5-2e6c51596b3e",
        "storage_key": "property/6767906449167635/019fec2d-da3b-74fb-b3f5-2e6c51596b3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.riverbanks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5878382912266439608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbanks-zoo--garden",
      "poi_latitude": "34.0086627",
      "poi_longitude": "-81.0733959",
      "poi_miles_from_property": "17.7 mi",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 803-779-8717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c7e-731d-952f-54394af04938",
        "storage_key": "property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryFyj1Wj-IgRuAteGx02lFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_0f2a9779-10e0-4d62-af0e-864e5df2adaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "North Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1320 Clemson Rd, Columbia, SC 29229, USA",
      "poi_short_description": "Basketball and tennis courts in a clean park offering events and classes.",
      "poi_long_description": "Basketball and tennis courts in a clean park offering events and classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-3ec6-7485-bf24-eefc0d17c32b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2a-3ec6-7485-bf24-eefc0d17c32b",
        "storage_key": "property/6767906449167635/019fec2a-3ec6-7485-bf24-eefc0d17c32b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://richlandcountyrecreation.com/centers/north-springs-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7948486822538547290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-springs-park",
      "poi_latitude": "34.1414633",
      "poi_longitude": "-80.8896608",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-736-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4cdb-7117-86e1-9555660db5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4cdb-7117-86e1-9555660db5d1",
        "storage_key": "property/6767906449167635/019fec2a-4cdb-7117-86e1-9555660db5d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbkLgiSq-IgRWpBI96ayTm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_54ce6bdf-1af1-4706-ab2c-c0abdaa18421",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Polo Road Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "730 Polo Rd, Columbia, SC 29223, USA",
      "poi_short_description": "Park featuring baseball and soccer fields plus a playground and paved parking.",
      "poi_long_description": "Park featuring baseball and soccer fields plus a playground and paved parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-3ecf-77fe-a5d3-1f4b9f658a90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2a-3ecf-77fe-a5d3-1f4b9f658a90",
        "storage_key": "property/6767906449167635/019fec2a-3ecf-77fe-a5d3-1f4b9f658a90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://richlandcountyrecreation.com/project/polo-road-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17169923230871549704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "polo-road-park",
      "poi_latitude": "34.08666669999999",
      "poi_longitude": "-80.8913889",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-736-1657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4cdb-7117-86e1-9555660db5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4cdb-7117-86e1-9555660db5d1",
        "storage_key": "property/6767906449167635/019fec2a-4cdb-7117-86e1-9555660db5d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQX9K0v6r-IgRCHfTVDXSR-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_98c1c4f0-10a9-4921-a377-3dc813079cc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Sesquicentennial State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9564 Two Notch Rd, Columbia, SC 29223, USA",
      "poi_short_description": "Forested park with a lake offering campsites, kayak & canoe rentals, a bicycle loop & nature trails.",
      "poi_long_description": "Forested park with a lake offering campsites, kayak & canoe rentals, a bicycle loop & nature trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-3f2f-759c-b17b-b460d0bc3d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2a-3f2f-759c-b17b-b460d0bc3d17",
        "storage_key": "property/6767906449167635/019fec2a-3f2f-759c-b17b-b460d0bc3d17.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://southcarolinaparks.com/sesqui",
      "poi_directions_map_url": "https://maps.google.com/?cid=15568892834672260028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sesquicentennial-state-park",
      "poi_latitude": "34.0869602",
      "poi_longitude": "-80.90633679999999",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 803-788-2706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4cdb-7117-86e1-9555660db5d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4cdb-7117-86e1-9555660db5d1",
        "storage_key": "property/6767906449167635/019fec2a-4cdb-7117-86e1-9555660db5d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2VkvhFGp-IgRvLPDrIvRD9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_bb260aeb-7aee-42c7-b8d8-ab49349c4d11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Columbia Metropolitan Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3250 Airport Blvd, West Columbia, SC 29170, USA",
      "poi_short_description": "Airport serving the Southeast & offering a range of commercial & charter flights.",
      "poi_long_description": "Airport serving the Southeast & offering a range of commercial & charter flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2d-fa9f-74ab-90ed-5e2aaecd0544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-fa9f-74ab-90ed-5e2aaecd0544",
        "storage_key": "property/6767906449167635/019fec2d-fa9f-74ab-90ed-5e2aaecd0544.webp",
        "width": 1215,
        "height": 1280
      },
      "poi_business_url": "http://flycae.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7649969984303653536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-metropolitan-airport",
      "poi_latitude": "33.941917",
      "poi_longitude": "-81.1220015",
      "poi_miles_from_property": "22.0 mi",
      "poi_walking_minutes": "8 hours 5 mins",
      "poi_biking_minutes": "2 hours 9 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 803-822-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2e-0c56-7109-b170-4d3f496aa093.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-0c56-7109-b170-4d3f496aa093",
        "storage_key": "property/6767906449167635/019fec2e-0c56-7109-b170-4d3f496aa093.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RR4iMu9-IgRoOLRYCsnKmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_467f0100-31d8-471c-bf8c-fa226ac8b154",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Blue Cross & Blue Shield of SC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 Faraway Dr, Columbia, SC 29223, USA",
      "poi_short_description": "Health-insurance company headquarters and corporate campus on Faraway Drive.",
      "poi_long_description": "Health-insurance company headquarters and corporate campus on Faraway Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-41ff-77b8-a3e1-167f68e3e1cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2a-41ff-77b8-a3e1-167f68e3e1cd",
        "storage_key": "property/6767906449167635/019fec2a-41ff-77b8-a3e1-167f68e3e1cd.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.southcarolinablues.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9984890566457078718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-cross--blue-shield-of-sc",
      "poi_latitude": "34.0677747",
      "poi_longitude": "-80.9146859",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-288-2227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4c7e-731d-952f-54394af04938",
        "storage_key": "property/6767906449167635/019fec2a-4c7e-731d-952f-54394af04938.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTb04Db-u-IgRvrPSZhF1kYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_15ad0146-2f5e-4b63-9f25-78e1976b002a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "poi_name": "Fort Jackson",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5450 Strom Thurmond Blvd, Columbia, SC 29207, USA",
      "poi_short_description": "U.S. Army basic-training installation on the east side of Columbia.",
      "poi_long_description": "U.S. Army basic-training installation on the east side of Columbia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2e-039e-716b-ae11-c735052438ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-039e-716b-ae11-c735052438ec",
        "storage_key": "property/6767906449167635/019fec2e-039e-716b-ae11-c735052438ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17603739079007642038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-jackson",
      "poi_latitude": "34.0237941",
      "poi_longitude": "-80.92879789999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-4eff-717d-8f26-a0e0705ebe09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2a-4eff-717d-8f26-a0e0705ebe09",
        "storage_key": "property/6767906449167635/019fec2a-4eff-717d-8f26-a0e0705ebe09.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3t50bSv-IgRtqHpemwLTfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_53a82b143d22fbd0ced618e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "day": "MON",
      "open_time": "11:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_292831ef1b8a77d92b673a9a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "day": "TUE",
      "open_time": "11:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_2b54caec31270b02cb4f9cd1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "day": "WED",
      "open_time": "11:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_36b24b383da7d9c389bee113",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "day": "THU",
      "open_time": "11:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_bfa3cd6aaab575a96a0ac670",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "day": "FRI",
      "open_time": "11:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f7b5a1d7d4cbf1117de92fda",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "rating": "5",
      "name": "Jeremiah Prescott",
      "text": "Cyrene was super nice and very understandable, she made sure all of our needs were met in-person and over the phone. Best customer service I ever experienced during apartment shopping definitely recommend!!",
      "date": "2026-06-12",
      "title": "false"
    },
    {
      "id": "ec_b86aaf7f21ed68e4fe92b0f7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "rating": "5",
      "name": "madilyn mckinney",
      "text": "We’re going on our second year of living at Ashcroft and have loved every minute! The townhomes are modern with plenty of space and natural light! The staff is helpful but still respects privacy by only reaching out with important updates and information. The community is close to multiple schools and shopping centers, and we get the perfect view of the sunset every night!",
      "date": "2024-06-08",
      "title": "false"
    },
    {
      "id": "ec_f1a31a7188b90d593b44dd16",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "rating": "4",
      "name": "Taylor Moore",
      "text": "My husband & I moved in 6 months ago & love it! The neighbors are friendly, we love the modern features, and the sidewalks in the neighborhoods make great walks! One issue has been our ring camera doesn’t work often, but literally that’s being nitty gritty! The other is people not picking up after their dogs (if you live in the areas with more grass) we feel safe here, maintenance is very cool, and the club house/pool area is nice.",
      "date": "2025-04-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_983a8c7f-6275-4137-973a-d9e697c872b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "3D walkthrough of the Laurens: 3 bed, 2.5 bath, about 1,250 sq ft",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Laurens",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=uDRPUTpCRJT"
    },
    {
      "id": "custom_79bb9185-aaf8-4f71-bc29-d843f1874745",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "3D walkthrough of the Dixon: 3 bed, 2.5 bath, about 1,483 sq ft",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Dixon",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mzPkW1cYWCU"
    },
    {
      "id": "custom_c4f3634c-eb58-430c-9b7e-1e56541da3b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "3D walkthrough of the Underwood: 3 bed, 2.5 bath, about 1,620 sq ft",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Underwood",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tXoJDkNvUHe"
    },
    {
      "id": "custom_8a5f6ac8-53f7-496e-9871-6ad3de933b91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "3D walkthrough of the Dahlia: 3 bed, 2.5 bath, about 1,671 sq ft",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Dahlia",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=s7onfBrQVsw"
    },
    {
      "id": "custom_931e38ba-31b0-4d96-8a8c-d635d31f3238",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "3D walkthrough of the Foxglove: 3 bed, 2.5 bath, about 1,671 sq ft",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Foxglove",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zCxdXMGJWLL"
    },
    {
      "id": "custom_0b8d1393-6547-478a-8a1c-e0a41b132365",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "3D walkthrough of the Townsend: 4 bed, 2.5 bath, about 1,719 sq ft",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Townsend",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bJM4hwkTk1u"
    }
  ],
  "faqs": [
    {
      "id": "custom_55a4ce20-396e-438d-8e8b-bcd73019f63d",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_cd32ad0a-b0ea-4612-9e6b-8de37e8269bd",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_0d031f3c-bd15-418d-85d0-247c16bf1293",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_5e96191b-eea9-4d74-9cef-3aa8a2153a44",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_067f1774-0558-4fa4-a639-614964de6622",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_56b1809b-a3de-4c7d-9c3f-efe9627ffd6b",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_3dd7b475-65f5-4112-a74d-993c2c2570b5",
      "question": "Trash",
      "answer": "Trash Fee - $33/mo",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_a91344bf-641b-40d9-874f-c970b40f6150",
      "question": "Landscape Services",
      "answer": "Townhomes: $45/month Single-family homes: $65/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_7bfa8bc3-03e5-4cee-bdb9-6862fffa7769",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_a25d7f6c-9a62-4ac1-a709-fb140f3d507f",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_74eed831-7fe3-4ad6-8836-e41d90e92804",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_04d3955a-93fa-46c0-8d35-f435a058f595",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_76399413-cde1-4165-bae2-f619ef790b61",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_ffc4b1dc-51e7-44bd-bf04-458b50e9f8eb",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_1cd4dbb0-d6a1-4da1-bb79-38f80b0d217a",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_2ba0fc97-061b-436a-9b71-6926d7f51d58",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_c1b66e78-bf0b-47a4-9d8d-e93d75075c93",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_0df8a0d5-8e29-4ae3-a300-0a82dbb8cea0",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_4625542a-d306-4f5a-918a-d5d82c78927f",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_f1e0ed1f-30c7-4c40-a3b0-263317698d7a",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_3cf48980417c1ec653eaf411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "2382960",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 100,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "Pet screening is mandatory prior to move in and prior to a pet occupying the unit. Fish are allowed as a pet with no pet fee or pet rent, however fish tanks are limited to 20 gallons. All pet vaccinations must be up to date and local jurisdiction registrations current.",
      "restrictions": "Contact Management for breed restrictions."
    },
    {
      "id": "ec_8afc26a25d2f97af8857e653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "2473180",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_294588dde68ecbc19119b0ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "yardi",
      "external_id": "2473179",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe3-da2a-702d-8daf-5a2cb2753b71",
      "lead_source": "LANDING_PAGE",
      "name": "Ashcroft - a Quinn Residence Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635"
    },
    {
      "lead_collector_id": "01a0abe3-db76-759c-90f8-b755aa63b6ef",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Ashcroft - a Quinn Residence Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635"
    },
    {
      "lead_collector_id": "01a18398-5855-70f0-9d39-d606270db737",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-columbia-sc",
      "search_query": "apartments with in-unit laundry Columbia SC",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Columbia, SC",
      "h2_subtitle": "Discover the comfort and convenience of having in-unit laundry available right in your home at Ashcroft. Enjoy hassle-free living in Columbia, SC.",
      "page_copy": "Welcome to Ashcroft, where convenience meets modern living. Our apartments offer the luxury of in-unit laundry, making daily chores easier than ever. Nestled in the heart of Columbia, SC, Ashcroft provides a comfortable and stylish living experience with amenities that cater to your lifestyle.\n\nAshcroft doesn't stop at in-unit laundry. Our community boasts a sparkling pool for relaxation, a playground for family fun, and spacious closets for all your storage needs. With granite countertops enhancing our kitchens and meticulous lawn maintenance, every detail has been designed to elevate your living experience in Richland County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments | Ashcroft, Columbia SC",
      "seo_description": "Find apartments with in-unit laundry at Ashcroft, Columbia, SC. Enjoy modern amenities like a pool and spacious closets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "columbia-sc-apartments-with-pool",
      "search_query": "Columbia SC apartments with a pool",
      "category": "Amenity",
      "h1_title": "Columbia, SC Apartments with Pool",
      "h2_subtitle": "Experience resort-style living at Ashcroft with our stunning pool. Dive into comfort and relaxation in Columbia, SC today.",
      "page_copy": "Ashcroft is the ideal destination for those seeking Columbia SC apartments with a pool. Our residents enjoy access to a beautiful, sparkling pool that serves as the perfect spot for both relaxation and recreation. Dive into convenience and luxury living, as our carefully designed amenities enhance your lifestyle.\n\nBeyond the pool, Ashcroft offers plenty more to love. Spacious closets, granite countertops, and meticulous lawn maintenance ensure you're living with style and ease. Families can delight in our playground, creating an engaging environment for everyone. Immerse yourself in modern living at Ashcroft, located in vibrant Columbia, SC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Columbia SC Apartments | Pool at Ashcroft",
      "seo_description": "Discover Ashcroft's Columbia, SC apartments featuring a pool. Enjoy spacious living with modern amenities like play areas and granite countertops.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-richland-county",
      "search_query": "pet-friendly apartments with dog park Richland County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Richland County",
      "h2_subtitle": "Discover pet-friendly living at Ashcroft, featuring a convenient dog park in Richland County. A paradise for you and your furry friend awaits.",
      "page_copy": "Ashcroft offers the pet-friendly apartments you're looking for, complete with a dog park in Richland County. Our community welcomes your furry companions with open arms and provides a dedicated area for them to play and socialize. Enjoy a lifestyle that embraces both your needs and those of your pets.\n\nIn addition to our pet-friendly amenities, Ashcroft also boasts beautiful features such as granite countertops, spacious closets, and an inviting pool. With a family-friendly playground and professional lawn maintenance, you'll find everything you need right here in Columbia, SC. Discover Ashcroft, where comfort meets convenience and where pets are part of the family.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments | Dog Park in Richland County",
      "seo_description": "Explore Ashcroft's pet-friendly apartments with a dog park in Richland County. Enjoy modern living with amenities for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "luxury-apartments-stainless-steel-appliances-29229",
      "search_query": "luxury apartments with stainless steel appliances 29229",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Indulge in luxury living at Ashcroft with our stunning apartments featuring stainless steel appliances in the 29229 area. Experience upscale living today.",
      "page_copy": "Welcome to Ashcroft, where luxury meets convenience in the heart of the 29229 area. Our exquisitely designed apartments boast high-end stainless steel appliances, adding a sleek and modern touch to your culinary space. Indulge in the opulence and sophistication that these features bring to everyday living.\n\nAshcroft doesn't stop at luxurious interiors—our community offers residents a range of top-notch amenities, including a shimmering pool, spacious closets, and meticulously maintained lawns. Families will appreciate our fun-filled playground, creating a vibrant community in Columbia, SC. Experience the very best in luxury apartments at Ashcroft and elevate your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments | Stainless Steel Appliances 29229",
      "seo_description": "Discover Ashcroft's luxury apartments with stainless steel appliances in the 29229 area. Upscale living with pools, playgrounds, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "smart-home-technology-apartments-columbia",
      "search_query": "smart-home technology apartments in Columbia",
      "category": "Amenity",
      "h1_title": "Smart-Home Technology Apartments in Columbia",
      "h2_subtitle": "Embrace the future at Ashcroft with our smart-home technology apartments in Columbia. Modern living with advanced conveniences awaits you.",
      "page_copy": "Ashcroft is redefining modern living with our smart-home technology apartments in Columbia. Experience a seamless blend of comfort and innovation tailored to enhance your lifestyle. From automated lighting and climate control to security features, our apartments are designed to meet the demands of contemporary living.\n\nIn addition to our tech-savvy interiors, Ashcroft offers an array of amenities such as a sparkling pool, spacious closets, and a playground, making it the perfect place for families and tech enthusiasts alike. Enjoy granite countertops and professionally maintained lawns that complement the high-tech comforts you seek. Discover a new way of living at Ashcroft, where technology and comfort converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Technology Apartments in Columbia",
      "seo_description": "Discover Ashcroft's smart-home technology apartments in Columbia. Modern living with amenities like pools, playgrounds, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-columbia-sc",
      "search_query": "three bedroom apartments Columbia SC",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedroom Apartments in Columbia",
      "h2_subtitle": "Explore Ashcroft's ample three bedroom apartments in Columbia, SC. Perfect for families seeking comfort and convenience.",
      "page_copy": "Discover the perfect blend of space and style at Ashcroft, where our three bedroom apartments in Columbia, SC, provide an ideal setting for families. With expansive layouts and modern amenities, these homes offer plenty of room to live and grow comfortably.\n\nEach apartment features high-quality finishes like granite countertops and spacious closets, ensuring style and functionality. Additionally, our community amenities including a refreshing pool, a fun playground, and expert lawn maintenance present an exceptional living experience in Columbia. Visit Ashcroft and find the perfect three-bedroom apartment that meets all your family's needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Columbia, SC | Ashcroft",
      "seo_description": "Find spacious three bedroom apartments at Ashcroft in Columbia, SC. Ideal for families seeking modern amenities and ample living space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-richland-county",
      "search_query": "four bedroom apartments Richland County",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments in Richland County",
      "h2_subtitle": "Discover Ashcroft's expansive four bedroom apartments in Richland County, ideal for larger families or those needing extra space.",
      "page_copy": "Experience the ultimate in spacious living with our four bedroom apartments at Ashcroft, located in the vibrant Richland County. Designed for larger households or those simply desiring more space, these apartments offer generous, well-appointed interiors with modern amenities perfectly suited for comfort and functionality.\n\nEach four bedroom unit features elegant granite countertops, ample closet space, and smart layout designs. Beyond your front door, enjoy convenient community amenities including a sparkling pool, a family-friendly playground, and perfectly manicured lawns. Whether entertaining guests or enjoying a quiet night in, Ashcroft provides the perfect backdrop for your lifestyle in Richland County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Richland County | Ashcroft",
      "seo_description": "Discover spacious four bedroom apartments at Ashcroft in Richland County, perfect for families looking for extra living space and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "apartments-near-sesquicentennial-state-park-sc",
      "search_query": "apartments near sesquicentennial state park sc",
      "category": "Park",
      "h1_title": "Apartments Near Sesquicentennial State Park, SC",
      "h2_subtitle": "Explore Ashcroft's convenient apartments near Sesquicentennial State Park, SC. Perfect for nature lovers seeking proximity to outdoor activities.",
      "page_copy": "Nestled in a prime location, Ashcroft offers apartments near Sesquicentennial State Park, SC, providing nature enthusiasts easy access to a serene escape. Our community is ideal for those who value both modern living and outdoor adventures, as the park is just a short drive away, providing opportunities for hiking, picnicking, and wildlife watching.\n\nAshcroft complements its beautiful surroundings with outstanding amenities like a sparkling pool, a vibrant playground for kids, and meticulously maintained grounds. Enjoy interiors adorned with granite countertops and spacious closets, making it just as inviting on the inside as it is on the outside. Experience the perfect balance of comfort and nature at Ashcroft.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sesquicentennial State Park, SC",
      "seo_description": "Find modern apartments near Sesquicentennial State Park, SC at Ashcroft. Perfect for outdoor enthusiasts seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "apartments-near-polo-road-park-columbia",
      "search_query": "apartments near polo road park columbia",
      "category": "Park",
      "h1_title": "Apartments Near Polo Road Park, Columbia",
      "h2_subtitle": "Discover Ashcroft's ideal location near Polo Road Park, Columbia. Perfect for those who love outdoor activities and family outings.",
      "page_copy": "Located just minutes from Polo Road Park, Ashcroft offers the ideal setting for residents who cherish proximity to outdoor recreation. Enjoy the convenience of having expansive park facilities nearby, perfect for sports, picnics, and family gatherings.\n\nOur apartments boast features like spacious closets and elegant granite countertops, ensuring a comfortable and stylish living environment. Community amenities such as a refreshing pool, a playful playground, and comprehensive lawn maintenance provide a relaxing lifestyle. Choose Ashcroft and enjoy the best of both worlds: modern living and easy access to Polo Road Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Polo Road Park, Columbia | Ashcroft",
      "seo_description": "Explore apartments near Polo Road Park in Columbia, SC at Ashcroft. Ideal for outdoor lovers seeking proximity to recreation and modern comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167635",
      "source": "generator",
      "page_item_url": "apartments-by-north-springs-park-richland-county",
      "search_query": "apartments by north springs park richland county",
      "category": "Park",
      "h1_title": "Apartments by North Springs Park, Richland County",
      "h2_subtitle": "Experience Ashcroft's prime location by North Springs Park, Richland County. Ideal for an active lifestyle within a vibrant community.",
      "page_copy": "Ashcroft Apartments offers a perfect living experience right by North Springs Park in Richland County, blending convenience and leisure seamlessly. For those who appreciate the outdoors, the close proximity allows effortless access to the park's lush greenery and recreational facilities, perfect for walking, biking, and family activities.\n\nOur community features beautifully designed apartments with modern amenities such as granite countertops and spacious closets. Residents enjoy an array of amenities including a sparkling pool, a family-friendly playground, and meticulously maintained grounds. At Ashcroft, you can enjoy a modern lifestyle with the added bonus of being steps away from the natural beauty of North Springs Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by North Springs Park, Richland County",
      "seo_description": "Find comfortable apartments by North Springs Park, Richland County at Ashcroft. Perfect for outdoor enthusiasts seeking a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977250055"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P946W8RT"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57156780639"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/x1p888lopd6"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/a2bf17ee-5354-4632-9bac-50647ecac3b0/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f5763c96-ff93-11ef-945f-9febd16aa613"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-741-1332"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "855-571-0636"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977250055",
  "custom_google_gtm_id": "GTM-P946W8RT",
  "custom_rollout_phase": "Phase 1",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57156780639",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/x1p888lopd6",
  "custom_self_guided_tour_url": "https://selftournow.com/property/a2bf17ee-5354-4632-9bac-50647ecac3b0/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f5763c96-ff93-11ef-945f-9febd16aa613",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "877-741-1332",
  "custom_paid_social_tracking_phone_number": "855-571-0636",
  "custom_audioeye_site_id": "a3cc032d-4e5f-4354-a37f-2a50fa90600d",
  "custom_audioeye_site_hash": "c75b108df11ab7d7d9f8f68789df3c59"
};

export const generatedAt = '2026-10-29T18:52:32.387Z';
